import 'angular';
import {identity} from 'lodash-es';
import Features from '../feature-manager/Features';
import AppConstants from '../gorillaboy/AppConstants';

function TasksListViewDirectiveFactory() {
    return {
        restrict: 'E',
        scope: true,
        templateUrl: './tasks/list_view.html',
        link: angular.noop
    }
}

 angular.module('GorillaBoy.Tasks')
.directive('tasksListView', TasksListViewDirectiveFactory);
